module.exports = __webpack_public_path__ + "img/subsuccess.721f752e.svg";